import { Option } from 'src/components/Select';
import { ShekelSign } from '../../../../viewsTypes';
import { DashboardData } from '../dashboardViewSlice/types';
import { Box } from '@mui/material';
import React from 'react';

export const vendorsOptions: Option[] = [
  {
    value: 'וולט',
    label: 'וולט',
    // Icon: (
    //   <Box
    //     component="img"
    //     src="https://upload.wikimedia.org/wikipedia/commons/b/b0/Wolt-app-icon-2019.png"
    //     height={16}
    //   />
    // ),
  },
  {
    value: 'שופרסל',
    label: 'שופרסל',
    // Icon: (
    //   <Box
    //     component="img"
    //     src="https://play-lh.googleusercontent.com/FZdoorzxUpImwSY5Xh8Ou1ZEOTqI_1JqYdgedTrr6fOgPnkdbm-3JveoNG_AmT6v7dg"
    //     height={16}
    //   />
    // ),
  },
  {
    value: 'apple',
    label: 'Apple',
    // Icon: (
    //   <Box
    //     component="img"
    //     src="https://w7.pngwing.com/pngs/684/943/png-transparent-apple-logo-computer-icons-apple-logo-heart-logo-computer-wallpaper-thumbnail.png"
    //     height={16}
    //   />
    // ),
  },
  {
    value: 'סיבוס',
    label: 'סיבוס',
    // Icon: (
    //   <Box
    //     component="img"
    //     src="https://yt3.googleusercontent.com/ytc/AIdro_laM7-osYwvcS3Wrfm2F8oPanJ-EnjS-9EVC39u=s900-c-k-c0x00ffffff-no-rj"
    //     height={16}
    //   />
    // ),
  },
  {
    value: 'amazon',
    label: 'Amazon',
    // Icon: (
    //   <Box
    //     component="img"
    //     src="https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/amazon-512.png"
    //     height={16}
    //   />
    // ),
  },
];

export const data: DashboardData = {
  expenses: {
    total: {
      receipts: { total: 79, change: 0.034 },
      expenses: { total: 2420, change: 0.034 },
    },
    dataPoints: [
      { x: 'january', y: 2800 },
      { x: 'february', y: 2300 },
      { x: 'march', y: 2500 },
      { x: 'april', y: 2300 },
      { x: 'may', y: 2500 },
      { x: 'june', y: 2600 },
    ],
    timeSpan: {
      count: 6,
      timeUnit: 'M',
    },
  },
  status: {
    score: 1,
    violatingCount: 0,
    timeSpan: {
      count: 3,
      timeUnit: 'M',
    },
  },
  receipts: {
    total: {
      receipts: { total: 28 },
      expenses: { total: 2391, unit: ShekelSign },
    },
    vendors: [
      {
        vendorId: '0',
        name: vendorsOptions[0].label,
        logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b0/Wolt-app-icon-2019.png',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
      {
        vendorId: '1',
        name: vendorsOptions[1].label,
        logo: 'https://play-lh.googleusercontent.com/FZdoorzxUpImwSY5Xh8Ou1ZEOTqI_1JqYdgedTrr6fOgPnkdbm-3JveoNG_AmT6v7dg',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
      {
        vendorId: '2',
        name: vendorsOptions[2].label,
        logo: 'https://w7.pngwing.com/pngs/684/943/png-transparent-apple-logo-computer-icons-apple-logo-heart-logo-computer-wallpaper-thumbnail.png',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
      {
        vendorId: '3',
        name: vendorsOptions[3].label,
        logo: 'https://yt3.googleusercontent.com/ytc/AIdro_laM7-osYwvcS3Wrfm2F8oPanJ-EnjS-9EVC39u=s900-c-k-c0x00ffffff-no-rj',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
      {
        vendorId: '4',
        name: vendorsOptions[4].label,
        logo: 'https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/amazon-512.png',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
    ],
    timeSpan: {
      count: 30,
      timeUnit: 'd',
    },
  },
};
